import { render } from "./UserView.vue?vue&type=template&id=72b41cf5&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=72b41cf5&scoped=true&lang=css"
import "./UserView.vue?vue&type=style&index=1&id=72b41cf5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b41cf5"]])

export default __exports__